<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/r4lJEK/tc-custom/9781250128539.jpg?1738254592875" alt="This image is the cover for the book Deep Dark Blue"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deep Dark Blue
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A memoir of surviving sexual abuse in the Air Force academy. </b><i><br/><br/>I want to be in the Air Force someday.<br/></i><br/>These are the words Polo Tate engraved on her junior dog tags at age eleven. It was an unpopular dream for most young girls, but her hard work paid off and at age eighteen, Polo started basic training at the United States Air Force Academy.<br/><br/>She does everything right, from academics to athletics. But no one prepared her for what came next: physical, sexual, and emotional abuse at the hands of her superiors. Harassment from peers who refused to believe her story. <br/><br/><i>Deep Dark Blue</i> is more than a memoir about sexual assault. It’s about breaking boundaries but also setting them. It's about learning to trust your instincts. It's a story of survival, resilience, and finally, finding your joy.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Polo Tate
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Feiwel & Friends
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?175cfe72